import Vue from 'vue'
import VueRouter from 'vue-router'
import PerformancePortalView from '../views/PerformancePortalView.vue'
import StartView from '../views/StartView.vue'
import i18n from "@/plugins/i18n";

Vue.use(VueRouter)

// Valid language codes
const VALID_LOCALES = ['en', 'de', 'fr'];
const DEFAULT_LOCALE = 'en';

// Helper function to validate and get a valid locale
function getValidLocale(locale) {
  return VALID_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
}

const routes = [
  {
    path: '/',
    redirect: `${i18n.locale}`,
  },
  {
    path: '/:locale',
    component: StartView,
    props: true,
    beforeEnter: (to, from, next) => {
      const validLocale = getValidLocale(to.params.locale);
      if (validLocale === to.params.locale) {
        next();
      } else {
        // Redirect to valid locale, preserving any additional path
        const pathParts = to.path.split('/').slice(2); // Remove empty string and invalid locale
        const newPath = pathParts.length > 0 ? `/${validLocale}/${pathParts.join('/')}` : `/${validLocale}`;
        next(newPath);
      }
    }
  },
  {
    path: '/:articleId',
    redirect: `${i18n.locale}/:articleId`
  },
  {
    path: '/:locale/:articleId',
    name: 'performanceportal',
    component: PerformancePortalView,
    props: true
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /////
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // e.g., if we have `/some/deep/nested/route` and `/some`, `/deep`, and `/nested` have titles,
  // `/nested`'s will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.metaTags);

  // Handle missing locale parameter
  if (!to.params.locale) {
    const validLocale = getValidLocale(i18n.locale);
    return next({ name: to.name, params: { ...to.params, locale: validLocale } });
  }

  // Validate and set locale
  const validLocale = getValidLocale(to.params.locale);
  if (to.params.locale !== validLocale) {
    // Invalid locale detected, redirect to valid locale
    const pathParts = to.path.split('/');
    pathParts[1] = validLocale; // Replace the invalid locale with valid one
    return next(pathParts.join('/'));
  }

  // Set the validated locale
  if (i18n.locale !== validLocale) {
    i18n.locale = validLocale;
  }

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  } else if (previousNearestWithMeta) {
    document.title = previousNearestWithMeta.meta.title;
  } else {
    document.title = i18n.t('app.title');
  }
  return next();
});



export default router;
